import React, { useContext } from "react";

import WorksContext from "../Context/WorksContext";
import ProjectCard from "./ProjectCard";
import "./styles/Works.css";
import ScrollToTopOnMount from "./utilities/ScrollToTopOnMount";

const Works = ({ titulo, numeroDeElementos }) => {
  const { trabajos } = useContext(WorksContext);

  return (
    <>
      <ScrollToTopOnMount />
      <div className="c-works-title">{titulo}</div>
      <section className="c-works">
        {numeroDeElementos
          ? trabajos.slice(0, numeroDeElementos).map((trabajo) => {
              return (
                <ProjectCard
                  key={trabajo.trabajoid}
                  titulo={trabajo.nombre}
                  imagen={trabajo.img}
                  trabajoid={trabajo.trabajoid}
                />
              );
            })
          : trabajos.map((trabajo) => {
              return (
                <ProjectCard
                  key={trabajo.trabajoid}
                  titulo={trabajo.nombre}
                  imagen={trabajo.img}
                  trabajoid={trabajo.trabajoid}
                />
              );
            })}
      </section>
    </>
  );
};

export default Works;
